/* eslint-disable complexity */
import React, { FocusEvent } from 'react';
import { useIntl } from 'react-intl';
import Textbox from 'carbon-react/lib/components/textbox';
import Password from 'carbon-react/lib/components/password';
import { Option, Select } from 'carbon-react/lib/components/select';

import styles from './modal.scss';
import { FORM_FIELDS } from '../../../../../../../auth/src/core/constants';
import { AuthFormData, AuthTouchedValues } from './advisor';

const regions = [
  { id: 'EU', name: 'EU (http://app.futrli.com)' },
  { id: 'AU', name: 'AU (http://app.futrli.com.au)' }
];

interface Props {
  formValues: AuthFormData;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleBlur: (e: FocusEvent<HTMLInputElement>) => void;
  touchedValues: AuthTouchedValues;
  errors: Record<string, string>;
}

export const AdvisorAuthForm = ({ formValues, touchedValues, handleInputChange, handleBlur, errors }: Props) => {
  const intl = useIntl();

  return (
    <form className={styles.form}>
      <Textbox
        label={intl.formatMessage({ id: 'auth.login.futrli_advisor_email', defaultMessage: 'Futrli Advisor Email' })}
        placeholder={intl.formatMessage({
          id: 'common.enter_email',
          defaultMessage: 'Enter your email'
        })}
        value={formValues.username}
        onChange={handleInputChange}
        onBlur={handleBlur}
        name={FORM_FIELDS.username}
        error={!!errors?.username && touchedValues.username ? errors?.username : undefined}
        mb="20px"
      />
      <Password
        placeholder={intl.formatMessage({
          id: 'login.enter_password',
          defaultMessage: 'Enter a password'
        })}
        label={intl.formatMessage({
          id: 'auth.login.futrli_advisor_password',
          defaultMessage: 'Futrli Advisor Password'
        })}
        value={formValues.password}
        onChange={handleInputChange}
        onBlur={handleBlur}
        name={FORM_FIELDS.password}
        error={!!errors.password && touchedValues.password ? errors.password : undefined}
        mb="20px"
      />
      <Select
        label={intl.formatMessage({
          id: 'import_from_advisor.region',
          defaultMessage: 'Region'
        })}
        value={formValues.region}
        onChange={handleInputChange}
        onBlur={handleBlur}
        name="region"
        mb="20px"
      >
        {regions.map(o => (
          <Option key={o.id} value={o.id} text={o.name} />
        ))}
      </Select>
    </form>
  );
};
